import { ref, computed } from 'vue'
import ApiService from '@/services/api.js'

export function useInfoSection(locale) {
  // Reactive state
  const rawInfoCards = ref([])
  const isLoadingData = ref(false)

  // Computed info cards with proper locale reactivity
  const infoCards = computed(() => {
    console.log('🔄 [INFO CARDS COMPUTED] Computing cards...')
    console.log('   - Raw cards count:', rawInfoCards.value.length)
    console.log('   - Current locale:', locale?.value)
    
    if (rawInfoCards.value.length === 0) {
      console.log('⚠️ [INFO CARDS COMPUTED] No raw cards, returning empty array')
      return []
    }
    
    const processedCards = rawInfoCards.value.map(card => {
      const processed = {
        id: card.id,
        type: card.card_type || 'default',
        title: locale?.value === 'tr' ? (card.title_tr || card.title) : (card.title_en || card.title),
        description: locale?.value === 'tr' ? (card.description_tr || card.description) : (card.description_en || card.description),
        buttonText: locale?.value === 'tr' ? (card.button_text_tr || 'Detaylar') : (card.button_text_en || 'Details'),
        buttonAction: card.button_action || 'contact',
        backgroundImage: card.background_image,
        icon: card.icon,
        backgroundColor: card.background_color,
        textColor: card.text_color
      }
      console.log(`   - Card ${card.id}: ${processed.title} (${processed.type})`)
      return processed
    })
    
    console.log('✅ [INFO CARDS COMPUTED] Final processed cards:', processedCards)
    return processedCards
  })

  // Info cards yükleme
  const loadInfoCards = async () => {
    try {
      console.log('🔄 [INFO CARDS] Loading info cards data...')
      console.log('🌐 [INFO CARDS] Current locale:', locale?.value)
      isLoadingData.value = true
      
      const infoCardsData = await ApiService.getInfoCards()
      console.log('📋 [INFO CARDS] Raw API response:', infoCardsData)
      console.log('📋 [INFO CARDS] API response type:', typeof infoCardsData)
      console.log('📋 [INFO CARDS] Is array:', Array.isArray(infoCardsData))
      console.log('📋 [INFO CARDS] Data length:', infoCardsData?.length)
      console.log('📋 [INFO CARDS] API response type:', typeof infoCardsData)
      console.log('📋 [INFO CARDS] API response length:', infoCardsData?.length)
      
      if (infoCardsData && infoCardsData.length > 0) {
        rawInfoCards.value = infoCardsData
        console.log('✅ [INFO CARDS] Data loaded successfully:')
        console.log('   - Total cards:', rawInfoCards.value.length)
        console.log('   - Card titles (TR):', rawInfoCards.value.map(c => c.title_tr))
        console.log('   - Card types:', rawInfoCards.value.map(c => c.card_type))
        console.log('   - Full data:', rawInfoCards.value)
      } else {
        console.warn('⚠️ [INFO CARDS] No data received, using fallback')
        console.log('📋 [INFO CARDS] API returned:', infoCardsData)
        setFallbackInfoCards()
      }
    } catch (error) {
      console.error('❌ [INFO CARDS] API Error:', error)
      console.error('❌ [INFO CARDS] Error details:', {
        message: error.message,
        stack: error.stack,
        name: error.name
      })
      setFallbackInfoCards()
    } finally {
      isLoadingData.value = false
      console.log('⚙️ [INFO CARDS] Loading completed. isLoading:', isLoadingData.value)
    }
  }

  // Fallback info cards
  const setFallbackInfoCards = () => {
    console.log('🔄 [INFO CARDS] Setting fallback data...')
    rawInfoCards.value = [
      {
        id: 1,
        card_type: 'yellow-card',
        title_tr: 'Güneş Enerjisi Sistemleri',
        title_en: 'Solar Energy Systems',
        description_tr: 'Ev ve işyerleriniz için yüksek verimli güneş paneli sistemleri. Temiz enerji ile hem çevreyi koruyun hem de elektrik faturalarınızı azaltın.',
        description_en: 'High-efficiency solar panel systems for homes and businesses. Protect the environment and reduce your electricity bills with clean energy.',
        button_text_tr: 'Keşfet',
        button_text_en: 'Explore',
        button_action: 'contact',
        background_image: null,
        icon: null,
        background_color: null,
        text_color: null
      },
      {
        id: 2,
        card_type: 'black-card',
        title_tr: 'Enerji Depolama',
        title_en: 'Energy Storage',
        description_tr: 'Gelişmiş batarya teknolojileri ile ürettiğiniz enerjiyi depolayın. Kesintisiz güç sağlayın ve enerji bağımsızlığınızı artırın.',
        description_en: 'Store your generated energy with advanced battery technologies. Provide uninterrupted power and increase your energy independence.',
        button_text_tr: 'Detaylar',
        button_text_en: 'Details',
        button_action: 'contact',
        background_image: null,
        icon: null,
        background_color: null,
        text_color: null
      },
      {
        id: 3,
        card_type: 'image-card',
        title_tr: 'Uzman Danışmanlık',
        title_en: 'Expert Consulting',
        description_tr: 'Alanında uzman ekibimizle size özel enerji çözümleri geliştiriyoruz. Proje planlamadan kuruluma kadar her aşamada yanınızdayız.',
        description_en: 'We develop customized energy solutions with our expert team. We are with you at every stage from project planning to installation.',
        button_text_tr: 'İletişim',
        button_text_en: 'Contact',
        button_action: 'contact',
        background_image: 'https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
        icon: null,
        background_color: null,
        text_color: null
      }
    ]
    console.log('✅ [INFO CARDS] Fallback data set:', rawInfoCards.value.length, 'cards')
  }

  // Initialize
  console.log('🚀 [INFO CARDS] Initializing useInfoSection composable')
  loadInfoCards()

  return {
    infoCards,
    isLoadingData,
    loadInfoCards
  }
}